<h1>Vision Home</h1>

<div class="p-grid">
  <div class="p-col-12 p-md-6 p-lg-4 p-xl-3">
    @if (canSeePieceRate || canSeePieceRateAdmin) {
      <p-card header="Piece Rate">
        <ul>
          @if (canSeePieceRate) {
            <li>
              <a href="/warehousing/#/piece-rate-form">Piece Rate Entry Form</a>
            </li>
          }
          @if (canSeePieceRateAdmin) {
            <li>
              <a href="/admin/#/piece-rate-weeks">Piece Rate Weeks</a>
            </li>
          }
          @if (canSeePieceRateAdmin) {
            <li>
              <a href="/admin/#/piece-rate-config">Piece Rate Configuration Form</a>
            </li>
          }
        </ul>
      </p-card>
    }
  </div>
</div>
